/**
 * AdminIntakesRpcClient — AtomRpc integration for the admin intake worksheet
 * + magic-link lifecycle endpoints (list/get/create/update/finalize/…).
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminIntakesRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminIntakesRpcClient extends AtomRpc.Tag<AdminIntakesRpcClient>()(
  "AdminIntakesRpcClient",
  {
    group: AdminIntakesRpcs,
    protocol: makeRpcClientLayer(AdminIntakesRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
